import React from "react";
import { View, Image, TouchableOpacity, StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import {
  NavigationProp,
  useNavigation,
  useRoute} from "@react-navigation/native";
import SignInStyle from "./SignInPageStyle";
import commonStyles from "../../styles/commonStyles";
import AppText from "../../components/AppText";
import { fonts } from "../../styles/theme";

export const ACCOUNT_NOT_FOUND_TITLE = "Your email address is not registered";
export const DEFAULT_ACCOUNT_NOT_FOUND_MESSAGE =
  "Signup is available by invitation only. Please contact your referral, and they will send you a personalized invitation link to complete your registration.";

const AccountNotFound: React.FC = () => {
  const navigation = useNavigation<NavigationProp<any>>();
  const route: any = useRoute();
  const message: string =
    route?.params?.message || DEFAULT_ACCOUNT_NOT_FOUND_MESSAGE;

  return (
    <SafeAreaView style={styles.container}>
      <View style={SignInStyle.header}>
        <View style={SignInStyle.imageContainer}>
          <Image
            source={require("../../../assets/adaptive-icon.png")}
            style={{ width: 350, height: 100 }}
          />
          <AppText style={[SignInStyle.subHeaderText, commonStyles.mt5]}>
            #iamtheowner
          </AppText>
        </View>
      </View>
      <View style={styles.content}>
        <View style={styles.iconCircle}>
          <AppText style={styles.iconText}>!</AppText>
        </View>
        <AppText style={styles.title}>{ACCOUNT_NOT_FOUND_TITLE}</AppText>
        <AppText style={styles.message} testID="account-not-found-message">
          {message}
        </AppText>
        <TouchableOpacity
          style={styles.button}
          testID="close-account-not-found"
          onPress={() => navigation.navigate("SignIn")}
        >
          <AppText style={styles.buttonText}>Close</AppText>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const RED = "#D9534F";
const SLATE = "#5A6A85";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff"},
  content: {
    flex: 1,
    backgroundColor: "#F3F4F2",
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 24},
  iconCircle: {
    width: 72,
    height: 72,
    borderRadius: 36,
    backgroundColor: RED,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 32},
  iconText: {
    color: "#fff",
    fontSize: 40,
    lineHeight: 46,
    fontFamily: fonts.bold},
  title: {
    fontSize: 26,
    color: SLATE,
    textAlign: "center",
    marginBottom: 12,
    fontFamily: fonts.bold},
  message: {
    fontSize: 16,
    color: SLATE,
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 32,
    fontFamily: fonts.medium},
  button: {
    backgroundColor: RED,
    borderRadius: 6,
    height: 44,
    minWidth: 150,
    paddingHorizontal: 24,
    alignItems: "center",
    justifyContent: "center"},
  buttonText: {
    color: "#fff",
    fontSize: 15,
    fontFamily: fonts.regular}});

export default AccountNotFound;
